(function () {
  var config = window.Elixir_HeadingUnderlineConfig || {};
  // MARKUP, UL_STYLE and UL_OFFSET are mutable: sections/page-branding.liquid
  // swaps them per template through the Elixir_HeadingUnderline API below.
  var MARKUP = config.MARKUP;
  var ACCENT_MODE = config.ACCENT_MODE;
  var ACCENT_COLOR = config.ACCENT_COLOR;
  var ACCENT_GRADIENT = config.ACCENT_GRADIENT;
  var ACCENT_MARGIN = config.ACCENT_MARGIN;
  var UL_STYLE = config.UL_STYLE;
  var UL_OFFSET = config.UL_OFFSET;
  var MARKER_PADDING = config.MARKER_PADDING;
  var UL_COLOR = config.UL_COLOR;
  var UL_CONTRAST_TEXT = config.UL_CONTRAST_TEXT;
  var NUMBER_STYLE = config.NUMBER_STYLE;
  // Styles whose mark is vertically centered on the text (vs bottom-anchored)
  // Every 'marker_cover*' style paints behind the text.
  function isCoverStyle(style) {
    return /^marker_cover/.test(style || '');
  }
  var UL_CENTERED = UL_STYLE === 'circle' || isCoverStyle(UL_STYLE);
  // Section "Heading Accent Text" spans: the shared class plus legacy variants
  var TARGET = 'main .global-accent-text, main .accent-text, main .section-accent-text, main .testimonials__heading-accent';

  // A drawn cover marker is only in play when there is mark markup to inject.
  function isCoverMarker() {
    return !!MARKUP && isCoverStyle(UL_STYLE);
  }

  // An inline accent box hugs its text, so the stylesheet insets can drive the
  // mark. A block one is as wide as its container, so the mark has to be
  // measured off the text instead.
  function isInlineAccent(accent) {
    var display = getComputedStyle(accent).display;
    return display === 'inline' || display === 'inline-block';
  }

  function brandingAccent(accent) {
    return getComputedStyle(accent).getPropertyValue('--page-branding-accent-color').trim();
  }

  function applyBrandedColor(accent, fallback) {
    var s = accent.style;
    var value = fallback
      ? 'var(--page-branding-accent-color, ' + fallback + ')'
      : 'var(--page-branding-accent-color)';
    s.setProperty('color', value, 'important');
    s.setProperty('background-image', 'none', 'important');
    s.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
  }

  function applyColor(accent) {
    var s = accent.style;
    if (ACCENT_MODE === 'solid') {
      applyBrandedColor(accent, ACCENT_COLOR);
    } else if (brandingAccent(accent)) {
      applyBrandedColor(accent);
    } else if (ACCENT_MODE === 'gradient') {
      s.setProperty('background-image', ACCENT_GRADIENT, 'important');
      s.setProperty('-webkit-background-clip', 'text', 'important');
      s.setProperty('background-clip', 'text', 'important');
      s.setProperty('color', 'transparent', 'important');
      s.setProperty('-webkit-text-fill-color', 'transparent', 'important');
    }
  }

  // What a sibling actually paints, so an accent can tell whether any of the
  // rest of the heading shares its first or last line.
  function siblingRects(node) {
    if (node.nodeType === 3) {
      if (!node.nodeValue.trim()) return [];
      var range = document.createRange();
      range.selectNodeContents(node);
      return range.getClientRects();
    }
    return node.nodeType === 1 ? node.getClientRects() : [];
  }

  function onSameLine(a, b) {
    return Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top) > Math.min(a.height, b.height) / 2;
  }

  // Walks siblings in one direction looking for anything painted on `rect`'s
  // line. Document order means a match is necessarily beside the accent.
  function hasNeighbourOn(node, step, rect) {
    for (; node; node = node[step]) {
      var rects = siblingRects(node);
      for (var i = 0; i < rects.length; i++) {
        if (rects[i].width > 1 && onSameLine(rects[i], rect)) return true;
      }
    }
    return false;
  }

  function rgbOf(value) {
    if (!value) return null;
    var m = value.match(/^#?([0-9a-f]{6})$/i);
    if (m) {
      var i = parseInt(m[1], 16);
      return [(i >> 16) & 255, (i >> 8) & 255, i & 255];
    }
    m = value.match(/rgba?\(([^)]+)\)/i);
    if (!m) return null;
    var p = m[1].split(',').map(parseFloat);
    return p.length >= 3 ? [p[0], p[1], p[2]] : null;
  }

  function brightness(rgb) {
    return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
  }

  function ensureContrast(accent) {
    // A per-page style swap can leave a readable colour behind from a cover
    // style, which then paints the word white on a light section.
    if (accent.dataset.elxrContrast && ACCENT_MODE === 'none' && !brandingAccent(accent)) {
      accent.style.removeProperty('color');
      accent.style.removeProperty('-webkit-text-fill-color');
      delete accent.dataset.elxrContrast;
    }
    if (ACCENT_MODE !== 'none' || !coversText()) return;
    if (brandingAccent(accent)) return;
    if (paintsOwnGradient(accent)) return;
    var mark = rgbOf(UL_COLOR);
    var text = rgbOf(getComputedStyle(accent).color);
    if (!mark || !text) return;
    var markB = brightness(mark);
    if (Math.abs(markB - brightness(text)) >= 60) return;
    var readable = markB > 150 ? UL_CONTRAST_TEXT : '#FFFFFF';
    accent.style.setProperty('color', readable, 'important');
    accent.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    accent.dataset.elxrContrast = '1';
  }

  function applyMargin(accent) {
    // Sections can put the accent on its own line (sections/image-with-text.liquid
    // makes it a block). There is no neighbouring word to clear then, and a side
    // margin would only indent it away from the heading text, so leave the
    // spacing to that section's own CSS.
    if (!isInlineAccent(accent)) {
      accent.style.removeProperty('margin-left');
      accent.style.removeProperty('margin-right');
      return;
    }

    // A cover marker is drawn MARKER_PADDING past the text on each side, so
    // that overhang has to sit outside the gap or the blob crowds the words
    // next to it. Reserving it here keeps the visible gap equal to the
    // Accent side spacing setting whatever the marker padding is. Marks that
    // stay within the word's width need no clearance, so the accent is then
    // spaced like any other word.
    var overhangs = isCoverMarker() || (!!MARKUP && UL_STYLE === 'circle');
    var gap = overhangs ? Number(ACCENT_MARGIN) + (isCoverMarker() ? Number(MARKER_PADDING) : 0) : 0;
    // Inline !important so the global spacing beats per-section
    // margin-left !important rules (same trick as applyColor).
    accent.style.setProperty('margin-left', gap + 'px', 'important');
    accent.style.setProperty('margin-right', gap + 'px', 'important');

    // That gap only exists to hold the accent off the word beside it. Where the
    // accent starts or ends a line there is no such word, and the margin instead
    // indents it out of line with the rest of the heading — or, under centred
    // text, pulls the whole line off centre by half the gap. Both sides are
    // measured with the margins already on, since they are part of what decides
    // where the line breaks fall.
    var rects = fragmentRects(accent);
    if (!rects.length) return;
    if (!hasNeighbourOn(accent.previousSibling, 'previousSibling', rects[0])) {
      // A number opening the heading is a short, solid patch of marker, so its overhang reads as the
      // mark spilling out of the content box; inset it so the mark itself starts on the text edge.
      var inset = isCoverMarker() && isNumberAccent(accent) ? Number(MARKER_PADDING) : 0;
      accent.style.setProperty('margin-left', inset + 'px', 'important');
    }
    if (!hasNeighbourOn(accent.nextSibling, 'nextSibling', rects[rects.length - 1])) {
      accent.style.setProperty('margin-right', '0px', 'important');
    }
  }

  function paintsOwnGradient(accent) {
    var cs = getComputedStyle(accent);
    var clip = cs.webkitBackgroundClip || cs.backgroundClip;
    return clip === 'text' && /gradient/i.test(cs.backgroundImage || '');
  }

  function coversText() {
    return isCoverStyle(UL_STYLE);
  }

  function applyUnderline(accent) {
    if (!MARKUP) return;
    if (coversText() && ACCENT_MODE !== 'gradient' && paintsOwnGradient(accent)) return;
    if (accent.querySelector('.pdp-ul__mark')) return;
    if (accent.closest('.pdp-ul__content')) return;
    accent.classList.add('elxr-hul');
    accent.innerHTML =
      '<span class="pdp-ul__mark" aria-hidden="true">' + MARKUP + '</span>' +
      '<span class="pdp-ul__content">' + accent.innerHTML + '</span>';
  }

  // Unwraps an accent span back to its plain content so applyUnderline can
  // rebuild the mark, e.g. after a per-page style swap.
  function resetUnderline(accent) {
    var content = accent.querySelector('.pdp-ul__content');
    if (!content) return;
    accent.innerHTML = content.innerHTML;
    accent.classList.remove('elxr-hul', 'elxr-hul--wrapped');
  }

  function markOverhang() {
    if (isCoverMarker()) return MARKER_PADDING;
    return UL_STYLE === 'circle' ? 8 : 2;
  }

  // Bottom-anchored marks sit this far below the text baseline (before the
  // Underline offset setting). Fonts put their baseline at different heights
  // in the line box, so anchoring to the box instead lets the mark ride up
  // into letters in some fonts.
  var BASELINE_DROP_EM = 0.38;

  // A zero-size inline-block's bottom edge lands exactly on the baseline.
  function baselineY(content) {
    var probe = document.createElement('span');
    probe.style.cssText = 'display:inline-block;width:0;height:0;padding:0;border:0;vertical-align:baseline;';
    content.insertBefore(probe, content.firstChild);
    var y = probe.getBoundingClientRect().bottom;
    probe.remove();
    return y;
  }

  function markDrop(content) {
    return parseFloat(getComputedStyle(content).fontSize) * BASELINE_DROP_EM - UL_OFFSET;
  }

  function fragmentRects(content) {
    var rects = [];
    var all = content.getClientRects();
    for (var i = 0; i < all.length; i++) {
      if (all[i].width > 1) rects.push(all[i]);
    }
    return rects;
  }

  // A single absolutely-positioned mark stretches over the accent's whole
  // bounding box, which is only the text when the accent is inline and on one
  // line. Otherwise — wrapped text, or a block accent that fills its container
  // — position one mark per measured line fragment instead.
  function layoutMarks(accent) {
    var mark = accent.querySelector('.pdp-ul__mark');
    var content = accent.querySelector('.pdp-ul__content');
    if (!mark || !content) return;

    accent.querySelectorAll('.pdp-ul__mark--clone').forEach(function (c) { c.remove(); });

    var rects = fragmentRects(content);

    if (isCoverMarker()) {
      // Opening up the leading changes where the lines sit, so re-measure
      // once the class is on before placing anything.
      var wasWrapped = accent.classList.contains('elxr-hul--wrapped');
      accent.classList.toggle('elxr-hul--wrapped', rects.length > 1);
      if (accent.classList.contains('elxr-hul--wrapped') !== wasWrapped) {
        rects = fragmentRects(content);
      }
    }

    if (rects.length === 0 || (rects.length === 1 && isInlineAccent(accent))) {
      // Hidden, or a single line in an inline box that already hugs the text:
      // let the stylesheet drive the mark, except that a bottom-anchored mark
      // is re-anchored from the box edge to the baseline.
      mark.removeAttribute('style');
      if (rects.length && !UL_CENTERED) {
        var boxBottom = accent.getBoundingClientRect().bottom;
        mark.style.bottom = (boxBottom - baselineY(content) - markDrop(content)) + 'px';
      }
      return;
    }

    // The containing block of an abspos child of a wrapped inline element
    // is NOT the union bounding box: browsers resolve left/top from the
    // first line fragment's corner. Rather than guessing, calibrate: park
    // the mark at 0,0 and measure where it actually lands.
    mark.style.cssText = 'left:0;top:0;right:auto;bottom:auto;width:0;height:0;transform:none;';
    var origin = mark.getBoundingClientRect();

    var overhang = markOverhang();
    // Every line shares the font, so the first line's baseline-to-fragment
    // gap locates the baseline on each of the others.
    var descent = UL_CENTERED ? 0 : rects[0].bottom - baselineY(content);
    var drop = UL_CENTERED ? 0 : markDrop(content);

    rects.forEach(function (frag, i) {
      var m = mark;
      if (i > 0) {
        m = mark.cloneNode(true);
        m.classList.add('pdp-ul__mark--clone');
        accent.appendChild(m);
      }
      m.style.cssText =
        'right:auto;bottom:auto;transform:none;top:0;' +
        'left:' + (frag.left - origin.left - overhang) + 'px;' +
        'width:' + (frag.width + overhang * 2) + 'px;';
      // Mark height depends on its width (SVG aspect ratio), so measure
      // after sizing, then place the top edge explicitly instead of
      // relying on bottom/transform (which resolve against the same
      // ill-defined inline containing block).
      var h = m.getBoundingClientRect().height;
      var top;
      if (UL_CENTERED) {
        top = frag.top + frag.height / 2 - h / 2;
      } else {
        top = frag.bottom - descent + drop - h;
      }
      m.style.top = (top - origin.top) + 'px';
    });
  }

  function layoutAll() {
    document.querySelectorAll('main .elxr-num').forEach(function (accent) {
      raiseLeading(accent, shapeLeading);
    });
    if (!MARKUP) return;
    document.querySelectorAll('main .elxr-hul').forEach(function (accent) {
      // A breakpoint change can flip the accent between inline and block,
      // which changes whether it needs a side margin at all.
      applyMargin(accent);
      if (isCoverMarker() && isNumberAccent(accent)) raiseLeading(accent, coverLeading);
      layoutMarks(accent);
    });
  }

  var NUMBER_ONLY = /^[#\u2116]?\d{1,3}[.):]?$/;

  var NUMBER_SHAPES = ['circle', 'square', 'rounded', 'circle_outline', 'square_outline', 'plain'];
  var NUMBER_SOLID = ['circle', 'square', 'rounded'];
  var NUMBER_COLOR_PROPS = ['color', '-webkit-text-fill-color', 'background-image', 'background-clip', '-webkit-background-clip', '--elxr-num-color', 'font-size'];
  // Inline like the colour: section accent rules pin the accent's font size with !important.
  var NUMBER_SHAPE_SIZE = '0.75em';
  // On top of the word space, in the shape's own (smaller) em.
  var NUMBER_SHAPE_GAP = '0.4em';
  // Leading kept clear between a number's mark and the line below it.
  var NUMBER_MARK_GAP_EM = 0.15;
  var NUMBER_SHAPE_GAP_EM = 0.12;

  function isNumberAccent(accent) {
    return NUMBER_ONLY.test(accent.textContent.trim());
  }

  function numberShape() {
    return NUMBER_SHAPES.indexOf(NUMBER_STYLE) > -1 ? NUMBER_STYLE : '';
  }

  function numberHost(accent) {
    return accent.closest('h1, h2, h3, h4, h5, h6, p, li') || accent.parentElement;
  }

  function restoreLeading(host) {
    if (!host || host.dataset.elxrLh === undefined) return;
    var saved = host.dataset.elxrLh.split('|');
    if (saved[0]) host.style.setProperty('line-height', saved[0], saved[1]);
    else host.style.removeProperty('line-height');
    delete host.dataset.elxrLh;
  }

  // A number's mark is taller than the text, so tight heading leading lets the next line run into it.
  // Only ever opens the leading up; a heading already spaced wider keeps its own.
  function raiseLeading(accent, measure) {
    var host = numberHost(accent);
    if (!host) return;
    restoreLeading(host);
    var cs = getComputedStyle(host);
    var current = cs.lineHeight === 'normal' ? parseFloat(cs.fontSize) * 1.2 : parseFloat(cs.lineHeight);
    var target = measure(accent);
    accent.dataset.elxrLead = '1';
    if (!(target > current)) return;
    host.dataset.elxrLh = host.style.getPropertyValue('line-height') + '|' + host.style.getPropertyPriority('line-height');
    host.style.setProperty('line-height', target + 'px', 'important');
  }

  // --elxr-cover-ink is the marker's inked height in the accent's own em.
  function coverLeading(accent) {
    var probe = document.createElement('span');
    probe.style.cssText = 'display:inline-block;width:0;padding:0;border:0;height:calc(var(--elxr-cover-ink, 1em) + ' + NUMBER_MARK_GAP_EM + 'em);';
    accent.appendChild(probe);
    var h = probe.getBoundingClientRect().height;
    probe.remove();
    return h;
  }

  function shapeLeading(accent) {
    if (accent.classList.contains('elxr-num--plain')) return 0;
    return accent.getBoundingClientRect().height + parseFloat(getComputedStyle(numberHost(accent)).fontSize) * NUMBER_SHAPE_GAP_EM;
  }

  function numberColor(accent) {
    if (isCoverMarker()) return getComputedStyle(accent).getPropertyValue('--elxr-marker-color').trim() || UL_COLOR;
    return brandingAccent(accent) || (ACCENT_MODE === 'solid' ? ACCENT_COLOR : '') || UL_COLOR;
  }

  function resetNumber(accent) {
    if (accent.dataset.elxrLead) {
      restoreLeading(numberHost(accent));
      delete accent.dataset.elxrLead;
    }
    if (!accent.classList.contains('elxr-num')) return;
    accent.classList.remove('elxr-num');
    NUMBER_SHAPES.forEach(function (s) { accent.classList.remove('elxr-num--' + s); });
    NUMBER_COLOR_PROPS.forEach(function (p) { accent.style.removeProperty(p); });
    delete accent.dataset.elxrContrast;
  }

  // The shape replaces the accent style entirely, so it takes none of the overhang clearance
  // applyMargin reserves; the heading's own word space separates it from the title.
  function applyNumberShape(accent, shape) {
    resetUnderline(accent);
    var color = numberColor(accent);
    accent.classList.add('elxr-num', 'elxr-num--' + shape);
    var s = accent.style;
    var ink = color;
    if (NUMBER_SOLID.indexOf(shape) > -1) {
      var rgb = rgbOf(color);
      ink = rgb && brightness(rgb) > 150 ? UL_CONTRAST_TEXT : '#FFFFFF';
    }
    s.setProperty('--elxr-num-color', color);
    s.setProperty('color', ink, 'important');
    s.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    s.setProperty('background-image', 'none', 'important');
    s.setProperty('background-clip', 'border-box', 'important');
    s.setProperty('-webkit-background-clip', 'border-box', 'important');
    s.setProperty('margin-left', '0px', 'important');
    s.setProperty('margin-right', shape === 'plain' ? '0px' : NUMBER_SHAPE_GAP, 'important');
    if (shape !== 'plain') s.setProperty('font-size', NUMBER_SHAPE_SIZE, 'important');
    raiseLeading(accent, shapeLeading);
  }

  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(TARGET).forEach(function (accent) {
      if (accent.textContent.trim() === '') return;
      resetNumber(accent);
      var isNumber = isNumberAccent(accent);
      if (isNumber && numberShape()) {
        applyNumberShape(accent, numberShape());
        return;
      }
      if (!MARKUP) resetUnderline(accent);
      applyColor(accent);
      ensureContrast(accent);
      applyMargin(accent);
      if (isNumber && isCoverMarker()) raiseLeading(accent, coverLeading);
      applyUnderline(accent);
      layoutMarks(accent);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(document); });
  } else {
    apply(document);
  }
  document.addEventListener('shopify:section:load', function (e) { apply(e.target); });

  // Line breaks move when the viewport or fonts change.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(layoutAll, 150);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(layoutAll);
  }

  // Lets a template swap the underline style for its own page
  // (sections/page-branding.liquid) while reusing this layout logic.
  window.Elixir_HeadingUnderline = {
    setStyle: function (opts) {
      opts = opts || {};
      if (typeof opts.markup === 'string') MARKUP = opts.markup;
      if (typeof opts.style === 'string') {
        UL_STYLE = opts.style;
        UL_CENTERED = UL_STYLE === 'circle' || isCoverStyle(UL_STYLE);
      }
      if (opts.offset !== undefined && opts.offset !== null) UL_OFFSET = Number(opts.offset);
      if (typeof opts.numberStyle === 'string') NUMBER_STYLE = opts.numberStyle;
      document.querySelectorAll('main .elxr-hul').forEach(resetUnderline);
      apply(document);
    },
    relayout: layoutAll
  };
})();
